// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__bYeFR","wrapper":"Nav_wrapper__gosx8","section":"Nav_section__xYWMi","title":"Nav_title__fQb1K","item":"Nav_item__j+equ","link":"Nav_link__MYS7E"};